/**
 * ObjectListPage React component
 * 
 * @author    Jens Gruschel, Maurizio Tidei
 * @copyright © 2018 contexagon GmbH
 */


// React
import React from 'react';
import connect from "react-redux/es/connect/connect";
import PropTypes from 'prop-types';

// Material UI
import {withStyles} from "@material-ui/core";
import { Typography } from '@material-ui/core';

// Material UI components
import InfoIcon from "@material-ui/icons/Info";

// application components
import ObjectList from "./ObjectList";
import ObjectTypeMenu from "../base/ObjectTypeMenu";

// application
import {duplicateObject, editObject, createNewObject} from "../../operations/editing";
import {deleteObject, undeleteObject, searchTag} from "../../operations/listing";
import {openMediaOverlayForObject} from "../../operations/view";
import {changeUserSetting} from "../../operations/configuration";
import {selectUserSetting} from "../../redux/configuration/selectors";
import {selectTypeCreatable} from "../../redux/authorization/selectors";
import {selectObjectAccessInfo} from "../../redux/listing/selectors";


/**
 * ObjectListPage shows a list of object, for example a result of a search
 */
export class ObjectListPage extends React.Component {

    objectTypeMenu = undefined;

    handleAddObject = event => {
        if (this.props.types.length === 1) {
            this.props.createNewObject(this.props.types[0]);
        }
        else if (this.props.types.length > 1 && this.objectTypeMenu) {
            this.objectTypeMenu.open(event.currentTarget);
        }
    };
    
    render() {

        const { classes, items } = this.props;

        const onSelect = (index, object) => object.type === "mediaitem" ? this.props.openMediaOverlayForObject(object) : this.props.editObject(object.id);

        return (
            <div>
                {
                    this.props.note && <div className={classes.note}>
                        <InfoIcon fontSize="large" style={{float: "left"}}/>
                        <Typography component="p" className={classes.noteText}>{this.props.note}</Typography>
                    </div>
                }
                <ObjectList
                    items={items}
                    representation={this.props.representation}
                    onChangeRepresentation={(value) => this.props.changeUserSetting(this.props.representationId, value)}
                    onSelect={onSelect}
                    onDelete={(index, object) => this.props.deleteObject(object.id)}
                    onUndelete={(index, object) => this.props.undeleteObject(object.id)}
                    onEdit={(index, object) => this.props.editObject(object.id)}
                    onDuplicate={(index, object) => this.props.duplicateObject(object.id)}
                    onAdd={this.props.types.length > 0 ? this.handleAddObject : undefined}
                    onSearchTag={this.props.searchTag}
                />
                <ObjectTypeMenu
                    ref={component => {this.objectTypeMenu = component}}
                    types={this.props.types}
                    onSelect={this.props.createNewObject}
                />
            </div>
        );
    }
}

const mapStateToProps = state => {
    const filter = state.menu.currentFilter;
    const representationId = filter && filter.id ? "listRepresentation-" + filter.id.split('.').join('-') : "listRepresentation-general";
    const defaultRepresentation = filter && filter.defaultListRepresentation;
    const representation = selectUserSetting(state.configuration, representationId) || defaultRepresentation || "grid";
    return {
        items: state.listing.objectList.map(item => ({...item, accessInfo: selectObjectAccessInfo(state.listing, item.id)})),
        representationId: representationId,
        representation: representation,
        authorization: state.authorization,
        typeDefinitions: state.types.typeDefinitions,
        types: filter && filter.fields && filter.fields.types ? filter.fields.types.filter(
            typeId => selectTypeCreatable(state.authorization, typeId)
        ) : [],
        note: filter && filter.fields ? filter.fields.note : undefined
    }
};

ObjectListPage.propTypes = {
    items: PropTypes.array.isRequired
};

const styles = {
    note: {
        padding: 10,
        display: "flex",
        backgroundColor: "#147c9155",
        color: "#ffffff"
    },
    noteText: {
        marginLeft: 10,
        fontSize: 18,
        color: "#ffffff"
    }
};

export default connect(
    mapStateToProps,
    {
        editObject, createNewObject, deleteObject, undeleteObject, openMediaOverlayForObject,
        searchTag, duplicateObject, changeUserSetting
    }
)(withStyles(styles)(ObjectListPage));
